/**
 * Formatea un número para mostrarlo: una proporción estrictamente entre 0 y 1
 * es una tasa → porcentaje (0.41 → "41%"); el resto, tal cual, con coma
 * decimal (4.1 → "4,1").
 *
 * Compartido por `PropuestaCard.tsx` (Plan), `ContenidoEtapasBrief.tsx`
 * (Pieza) y `EmbudoFrecuencia.tsx` (Insights) — antes vivía duplicado línea
 * por línea en los dos primeros.
 *
 * CRITERIO DE LOS BORDES (`0` y `1`): se imprimen como número pelado, NO como
 * "0%" y "100%". El dato que llega acá no trae unidad, así que en los dos
 * extremos la función no puede saber qué está mirando, y hay casos reales de
 * los dos lados:
 *
 *  · `1` como multiplicador: en `PROPUESTAS_EJEMPLO` el respaldo de
 *    `saves_relativo` es `valor: 4.2, comparado_con: 1` contra "el promedio de
 *    tu cuenta" — o sea 1x. Con `1` → "100%" esa línea diría
 *    "4,2 vs 100% (el promedio de tu cuenta)", que es directamente falso.
 *  · `1` como tasa: un `porcion_gasto: 1` en el embudo sería el 100% del gasto.
 *  · `0` igual: "0 días sin contenido" y "0% del gasto" son los dos posibles.
 *
 * Ante el empate se elige la lectura neutra: "1" y "0" son ciertos midas lo que
 * midas, mientras que "100%" o "0%" inventan una unidad que el dato no dio. La
 * solución de fondo es que el respaldo traiga su unidad (cambio de contrato con
 * el backend); queda pendiente para cuando esta sección tenga datos reales.
 *
 * Consecuencia conocida y aceptada: hay un salto en el borde — 0.999 → "100%"
 * (redondeo del porcentaje) pero 1 → "1".
 *
 * Los negativos tampoco se leen como tasa: -0.41 → "-0,4".
 */
export function formatNumero(valor: number): string {
  if (valor > 0 && valor < 1) return `${Math.round(valor * 100)}%`;
  if (Number.isInteger(valor)) return String(valor);
  return valor.toFixed(1).replace(".", ",");
}
